import React, { useState } from "react";
import { toast } from "sonner";
import { Button, Flex, Popover, Text, TextArea } from "@radix-ui/themes";

import { InteractionInTrainingStatus } from "../types";
import { useCreateInteractionInTraining } from "../../../api/training";
import { InteractionType } from "../types";
import { useSimulatorTracking } from "../../simulator/useSimulatorTracking";
import { useGetTicket } from "../../../api/useGetTicket";

export const SendInteractionToTraining = ({
  interactionId,
  onSubmit = () => {},
  disableToast = false,
  refetch = () => {},
  interactionType = InteractionType.TICKET,
  topic = null,
}: {
  interactionId: string;
  onSubmit?: ({ good, comment }: { good: boolean; comment?: string }) => void;
  disableToast?: boolean;
  refetch?: () => void;
  interactionType?: InteractionType;
  topic?: { id: number; topic: string } | null;
}) => {
  const { trackTrainingDataAdded } = useSimulatorTracking();
  const [comment, setComment] = useState("");
  const { mutateAsync: createInteractionInTraining } =
    useCreateInteractionInTraining();
  const { data: ticketData } = useGetTicket(interactionId, true);

  const handleSubmit = async () => {
    onSubmit({
      good: false,
      comment,
    });
    await createInteractionInTraining({
      interactionId,
      interactionType,
      status: InteractionInTrainingStatus.PENDING,
      reason: comment,
      topicId: topic?.id,
      topicName: topic?.topic,
      name: ticketData?.ticket?.subject,
    });

    trackTrainingDataAdded(interactionId, 'ticket_sent');

    if (!disableToast) {
      toast(
        `${interactionType} sent to training. You can review it in the AI Agent Training panel.`
      );
    }
    refetch();
  };

  return (
    <div>
      <Popover.Root>
        <Popover.Trigger>
          <Button color="gray" variant="outline" size={"1"}>
            Send to Training
          </Button>
        </Popover.Trigger>
        <Popover.Content
          minWidth="400px"
          maxWidth="400px"
          style={{ zIndex: 1000000000000011 }}
        >
          <Flex direction="column" gap="3">
            <Text as="label" size="2" weight="bold">
              Why this interaction needs improvement?
            </Text>
            <TextArea
              placeholder="e.g., Missing key details, wrong tone, or inaccurate information..."
              value={comment}
              autoFocus
              onChange={(e) => setComment(e.target.value)}
            />
            <Flex justify="end" gap="3">
              <Popover.Close>
                <Button
                  style={{ cursor: "pointer" }}
                  color="gray"
                  variant="solid"
                  highContrast
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSubmit();
                  }}
                >
                  Submit
                </Button>
              </Popover.Close>
            </Flex>
          </Flex>
        </Popover.Content>
      </Popover.Root>
    </div>
  );
};
